














































































































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import SlideUpAndFadeIn from '../SlideUpAndFadeIn.vue';
import ChatMessage from './ChatMessage.vue';
import {QInput} from 'quasar';
import {
	INPSOpportunity,
	CustomerProfileStore,
	SessionStore,
	INPSRatingResponse
} from '../../store';
import {
	MonitoringService,
	WebService
} from '../../services';
import {ERouteName} from '../../router';
import {VueComponent} from '../../types';

@Component({
	components: {
		SlideUpAndFadeIn,
		ChatMessage
	}
})
export default class UnclaimedNPS extends Vue {
	@Prop({required: true})
	logoComponent!: VueComponent;

	@Prop({required: true})
	closeComponent!: VueComponent;

	cssVariables: Record<string, string> = {
		'--backgroundColor': '#000',
		'--backgroundColorLightened': '#00000030',
		'--textColor': '#FFF'
	};

	showLoadingOverlay = false;

	feedback = '';
	rating: number | null = null;

	showIntroduction = false;
	showNPSQuestion = false;
	showNPSFeedback = false;
	showUserFeedbackRating = false;
	showUserFeedbackText = false;
	showRatingFollowup = false;
	showFeedbackRequest = false;
	showThankYou = false;
	showReward = false;
	showCloseButton = false;
	showFakeLoading = false;

	npsSubmitted = false;

	npsOpportunity: INPSOpportunity | null = null;

	get ERouteName() {
		return ERouteName;
	}

	get customerProfile() {
		return CustomerProfileStore.customerProfile;
	}

	get brandConfig() {
		return SessionStore.brandConfig;
	}

	get ratingResponses(): INPSRatingResponse | null {
		if(this.rating === null || this.npsOpportunity === null) {
			return null;
		}
		// Set it here so TS stops complaining about it possibly being null, we already checked that
		const rating = this.rating;
		return this.npsOpportunity.npsSurvey.ratingResponses.find((ratingResponse) => {
			if(ratingResponse.start <= rating && ratingResponse.end >= rating) {
				return true;
			}
		}) || null;
	}

	@Watch('npsOpportunity')
	npsOpportunityChanged() {
		if(this.npsOpportunity) {
			this.cssVariables['--backgroundColor'] = this.npsOpportunity.npsSurvey.backgroundColor;
			this.cssVariables['--backgroundColorLightened'] = `${this.npsOpportunity.npsSurvey.backgroundColor}30`;
			this.cssVariables['--textColor'] = this.npsOpportunity.npsSurvey.textColor;
			this.showIntroduction = true;
			setTimeout(() => {
				this.showNPSQuestion = true;
			}, 3000);
			setTimeout(() => {
				this.showNPSFeedback = true;
			}, 5500);
		}
	}

	async created() {
		// Wait to get the profile to get the latest opportunities
		await CustomerProfileStore.fetchProfile();
		// We need to copy it because if we don't we lose it on profile refresh (after it's answered)
		this.npsOpportunity = CustomerProfileStore.nps(this.$route.params.id);
		console.log(this.npsOpportunity);
		if(!this.npsOpportunity) {
			this.$q.dialog({
				title: 'Error',
				message: 'This link has expired.'
			}).onDismiss(() => {
				this.$router.push({name: ERouteName.Home});
			});
		}
	}

	setRating(rating: number) {
		this.rating = rating;
		this.showNPSFeedback = false;
		this.showUserFeedbackRating = true;
		setTimeout(() => {
			this.scrollToBottom();
			this.showRatingFollowup = true;
		}, 500);

		setTimeout(() => {
			this.scrollToBottom();
			this.showFeedbackRequest = true;
			this.$nextTick(() => {
				(this.$refs.feedback as QInput).focus();
			});
		}, 3000);
	}

	async close() {
		// Auto-submit this if they try to close the modal and they have entered a rating
		if(!this.npsSubmitted && this.rating !== null) {
			await this.claimNPSOpportunity();
		}
		await this.$router.push({name: ERouteName.Home});
	}

	async noFeedback() {
		this.feedback = 'No Feedback';
		await this.claimNPSOpportunity();
	}

	scrollToBottom() {
		const body = (this.$refs.body as HTMLElement);
		if(body) {
			// If the body is even scrollable then make sure we are scrolled to the bottom
			if(body.scrollHeight > body.clientHeight) {
				const bottom = (this.$refs.bottom as HTMLElement);
				if(bottom) {
					bottom.scrollIntoView({behavior: 'smooth'});
				}
			}
		}
	}

	async claimNPSOpportunity() {
		if(this.npsOpportunity && this.rating !== null) {
			try {
				// this.showLoadingOverlay = true;
				this.showFeedbackRequest = false;
				this.showUserFeedbackText = true;
				this.showFakeLoading = true;
				await WebService.submitNPSSurvey(this.npsOpportunity.id, this.rating, this.feedback);
				this.npsSubmitted = true;
				setTimeout(() => {
					this.showFakeLoading = false;
					this.scrollToBottom();
					this.showThankYou = true;
					if(this.npsOpportunity && this.npsOpportunity.npsSurvey.rewardPoints > 0) {
						setTimeout(() => {
							this.scrollToBottom();
							this.showReward = true;
							setTimeout(() => {
								this.scrollToBottom();
								this.showCloseButton = true;
							}, 2100);
						}, 500);
					} else {
						setTimeout(() => {
							this.scrollToBottom();
							this.showCloseButton = true;
						}, 500);
					}
				}, 100);
				// this.showLoadingOverlay = false;
			} catch(error) {
				this.showFakeLoading = false;
				console.error(error);
				this.$q.dialog({
					title: 'Error',
					message: 'There was a problem submitting your feedback.'
				});
				MonitoringService.captureException(error);
			}
		}
	}
}
